module.exports = __webpack_public_path__ + "img/scene2.473e3d28.jpg";